import React from 'react';
import { ClipboardCheckIcon, FileTextIcon, Grid3x3Icon, MapIcon, RulerIcon } from 'lucide-react';
import { SectionCTA } from '../SectionCTA';
import { tools } from '../../data/content';
const icons = [FileTextIcon, Grid3x3Icon, MapIcon, RulerIcon, ClipboardCheckIcon];
export function Tools() {
  return <section className="bg-navy-950 px-5 py-16 text-white md:py-24" aria-labelledby="tools-title" data-id="element-327" data-mp="2dj7tqrieg84k">
      <div className="mx-auto max-w-5xl" data-id="element-328" data-mp="28keofmd9nnfh">
        <p className="text-center font-display text-xs font-extrabold uppercase tracking-[0.14em] text-gold sm:text-sm" data-id="element-329" data-mp="28lg1txhr8m0d">
          Plus — practical ECG study tools
        </p>
        <h2 id="tools-title" className="mx-auto mt-3 max-w-3xl text-center font-display text-3xl font-black leading-tight sm:text-5xl text-balance" data-id="element-330" data-mp="1yu37mz8hhjr6">
          Everything You Need to Make Your ECG Study Sessions More Organized
        </h2>

        <ul className="mt-12 grid gap-x-10 md:grid-cols-2" data-id="element-331" data-mp="1ktio20uqvjwm">
          {tools.map((tool, index) => {
          const Icon = icons[index % icons.length];
          return <li key={tool.title} className="flex items-start gap-4 border-t border-white/10 py-6" data-id="element-332" data-mp="19zwjx844er52" data-mpi={index}>
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-pulse text-white" data-id="element-333" data-mp="w91k0lblnkdm">
                  <Icon className="h-6 w-6" aria-hidden="true" data-id="element-334" data-mp="109lhjq034q0a" />
                </span>
                <div data-id="element-335" data-mp="1nzfsg20ug4hw">
                  <h3 className="font-display text-lg font-extrabold uppercase leading-snug" data-id="element-336" data-mp="1o10ipfg4l19y">{tool.title}</h3>
                  <p className="mt-1.5 text-[15px] leading-relaxed text-white/75" data-id="element-337" data-mp="1sxqy00k3vsub">{tool.body}</p>
                </div>
              </li>;
        })}
        </ul>

        <p className="mt-6 text-center text-sm text-white/60" data-id="element-338" data-mp="1jxkpkt39lj20">
          These resources complement the six main volumes. They are educational study aids, not validated bedside
          diagnostic or treatment protocols.
        </p>

        <SectionCTA dark label="Yes! I want all 6 ECG volumes and practical tools" data-id="element-339" data-mp="8kiak2gtd1jy" />
      </div>
    </section>;
}